import React, { useCallback } from 'react';
import { HeaderIcon, IconCart } from '@banhala/ui-kit';
import { useNavigator } from 'shared/src/utils';
import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { useOnForeground } from 'shared/src/hooks';
import { queryKey } from 'shared/src/constant';
import { cartService } from '../api';

interface CartIconProps {
  backgroundColor?: 'white' | 'transparent';
  onPressCart: () => void;
}

interface CartIconInternalProps {
  onPress: () => void;
  backgroundColor: 'white' | 'transparent';
}

export const CartIcon: React.FC<CartIconProps> = ({
  backgroundColor,
  ...props
}) => {
  const { navigator } = useNavigator();
  return (
    <React.Suspense
      fallback={
        <HeaderIcon
          testID={'장바구니버튼'}
          onPress={() => {
            handlePressIconCart(navigator);
            props.onPressCart?.();
          }}
        >
          <IconCart />
        </HeaderIcon>
      }
    >
      <CartIconInternal
        backgroundColor={backgroundColor ?? 'white'}
        onPress={() => {
          handlePressIconCart(navigator);
          props.onPressCart?.();
        }}
      />
    </React.Suspense>
  );
};

const handlePressIconCart = (
  navigator: ReturnType<typeof useNavigator>['navigator'],
) => {
  navigator.moveToWebview('Cart');
};

const CartIconInternal = ({
  onPress,
  backgroundColor,
}: CartIconInternalProps) => {
  const queryClient = useQueryClient();

  useOnForeground(
    useCallback(() => {
      queryClient.invalidateQueries({ queryKey: queryKey.cartMeta });
    }, [queryClient]),
  );

  const { data: cartsCount } = useSuspenseQuery({
    queryKey: queryKey.cartMeta,
    queryFn: cartService.getCartMeta,
    select: data => data.carts_count,
    staleTime: 0,
  });

  return (
    <HeaderIcon
      onPress={onPress}
      badgeNum={cartsCount > 0 ? cartsCount : undefined}
      testID={'장바구니버튼'}
      backgroundColor={backgroundColor}
    >
      <IconCart />
    </HeaderIcon>
  );
};
